export function GuideSplash() {
    return (
        <div className="guide white">
            <h3>Paragon Conquer Guide</h3>
            <p>Welcome to the Paragon Conquer Guide!</p>
            <p>Select a category above to access an extensive knowledgebase to help guide you though playing Paragon Conquer!</p>
            <p>If your question cannot be found in our Guide, please feel free to reach out for help in our <a href="https://www.discord.com/">Discord</a></p>
        </div>
    );
}